export const detectarDispositivo = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);
    
    const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    
    let os = 'Unknown';
    
    if (/android/i.test(userAgent)) {
        os = 'Android';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        os = 'iOS';
    } else if (/win/i.test(userAgent)) {
        os = 'Windows';
    } else if (/mac/i.test(userAgent)) {
        os = 'Mac';
    } else if (/linux/i.test(userAgent)) {
        os = 'Linux';
    }
    
    let tipoDispositivo = '';
    
    if (isTablet) {
        if (os === 'iOS') {
            tipoDispositivo = 'Tablet iPad';
        } else if (os === 'Android') {
            tipoDispositivo = 'Tablet Android';
        } else {
            tipoDispositivo = `Tablet ${os}`;
        }
    } else if (isMobile) {
        if (os === 'iOS') {
            if (/iPhone/.test(userAgent)) {
                tipoDispositivo = 'Mobile iPhone';
            } else if (/iPod/.test(userAgent)) {
                tipoDispositivo = 'Mobile iPod';
            } else {
                tipoDispositivo = 'Mobile iOS';
            }
        } else if (os === 'Android') {
            tipoDispositivo = 'Mobile Android';
        } else {
            tipoDispositivo = `Mobile ${os}`;
        }
    } else {
        tipoDispositivo = `Desktop ${os}`;
    }
    
    return tipoDispositivo;
};

